import { connect } from "react-redux";
import Component from "../components/AppMenuSearchBox";
import { search, clearSearch, setUIVisibilityState } from "../actions";
var mapStateToProps = function(state, ownProps) {
    return {
        query: state.search.query || "",
        isSearching: state.loading.indexOf("search") > -1,
        isLoading: state.loading.indexOf("fetch_searchable") > -1,
        hasResults: Boolean(state.search.results),
        favOnly: state.uiVisibilityState.favOnly
    };
};
var mapDispatchToProps = function(dispatch, ownProps) {
    return {
        toggleFavOnly: function(favOnly) {
            dispatch(setUIVisibilityState({
                state: {
                    favOnly: favOnly
                }
            }));
        },
        doSearch: function(query) {
            dispatch(search({
                query: query
            }));
        },
        clearSearch: function() {
            dispatch(clearSearch());
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Component);
